import { ApiError } from "../data/api";
import { t } from "./sprache";

/** Ab diesem Anteil (Prozent) weist die Abo-Seite auf den knappen Speicher hin; die Glocke meldet ab derselben Stufe (0134). */
export const SPEICHER_HINWEIS_AB = 80;

/** Anteil des belegten Speichers in ganzen Prozent (0–100); unbegrenzt oder ohne Grenze: 0. */
export function speicherProzent(bytes: number, limitGb: number): number {
  if (!(limitGb > 0)) return 0;
  return Math.min(100, Math.round((bytes / (limitGb * 1024 ** 3)) * 100));
}

/** Klartext zur Speicherlage für die Abo-Seite; null, solange unter der Hinweisstufe. */
export function speicherHinweis(bytes: number, limitGb: number): string | null {
  if (limitGb < 0) return null;
  if (bytes >= limitGb * 1024 ** 3) {
    return t("Speicher voll: neue Dateien werden abgelehnt. Rechnungen, Belege und unterschriebene Verträge werden weiter abgelegt. Entferne nicht mehr benötigte Dateien oder wähle einen größeren Tarif.",
      "Storage full: new files are rejected. Invoices, receipts and signed contracts are still stored. Remove files you no longer need or choose a larger plan.");
  }
  const p = speicherProzent(bytes, limitGb);
  if (p < SPEICHER_HINWEIS_AB) return null;
  return t(`Speicher zu ${p} % belegt. Über der Grenze werden neue Dateien abgelehnt; Rechnungen, Belege und unterschriebene Verträge nie.`,
    `Storage ${p} % used. Above the limit, new files are rejected; invoices, receipts and signed contracts never are.`);
}

/**
 * Fehler des Speichers beim Hochladen: die Sperre der Datenbank (0134, Meldung „Der Speicher des Tarifs ist voll“) kommt über
 * die Storage-Schnittstelle ohne Hinweis-Schlüssel an. Sie bekommt hier den Schlüssel limit:storage_gb und einen klaren Text.
 */
export function uploadFehler(message: string): ApiError {
  const voll = /Speicher des Tarifs ist voll(?: \((\d+) GB\))?/.exec(message);
  if (voll) {
    const gb = voll[1];
    return new ApiError(
      t(`Der Speicher des Tarifs ist voll${gb ? ` (${gb} GB)` : ""}. Entferne nicht mehr benötigte Dateien oder wähle einen größeren Tarif. Rechnungen, Belege und Verträge lassen sich weiter ablegen.`,
        `The plan's storage is full${gb ? ` (${gb} GB)` : ""}. Remove files you no longer need or choose a larger plan. Invoices, receipts and contracts can still be stored.`),
      { code: "P0001", hint: "limit:storage_gb" });
  }
  return new ApiError(message);
}

/**
 * Dateiname für einen Speicherpfad in reinem ASCII (Praxistest G-022): der Speicher lehnt Schlüssel mit Umlauten ab („Invalid key“).
 * ä→ae, ö→oe, ü→ue, ß→ss, übrige Akzente fallen weg, alles andere außer Buchstaben, Ziffern, Punkt, Minus und Unterstrich wird „-“.
 */
export function asciiDateiname(name: string, fallback: string): string {
  const s = name.normalize("NFC")
    .replace(/Ä/g, "Ae").replace(/Ö/g, "Oe").replace(/Ü/g, "Ue").replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/[^A-Za-z0-9._-]+/g, "-").replace(/-{2,}/g, "-").replace(/^[.-]+/, "").replace(/-+(\.[A-Za-z0-9]+)?$/, "$1");
  return (s || fallback).slice(-120);
}
